import { useSearchParams } from '@framework/next/navigation';
import URL from '@/creditflowresearch/Router/urlConstants';

export const useGetLinkToAllStats = (): string => {
  const searchParams = useSearchParams();
  const params = new URLSearchParams();

  const products = searchParams.get('products');
  const markets = searchParams.get('markets');
  const regions = searchParams.get('regions');

  if (products) params.set('products', products);
  if (markets) params.set('markets', markets);
  if (regions) params.set('regions', regions);

  const queryString = params.toString();

  return queryString
    ? `${ URL.CREDIT_FLOW_STATS_LIST_ALL }?${ queryString }`
    : URL.CREDIT_FLOW_STATS_LIST_ALL;
};
